import { FC } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

import Dialog from "../dialog";

interface DeleteDialogProps {
  isOpen: boolean;
  isLoading: boolean;
  entity: string;
  onClose: () => void;
  onDelete: () => void;
}

const DeleteDialog: FC<DeleteDialogProps> = ({
  isOpen,
  isLoading,
  entity,
  onDelete,
  onClose,
}) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Confirmation"
      actionClassName="confirmation-dialog-action"
      maxWidth="sm"
      action={
        <>
          <div className="text-center">
            <Button
              type="button"
              variant="contained"
              className="btn button-outline-secondary"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="contained"
              className="btn primary-button ms-2"
              onClick={onDelete}
              autoFocus
            >
              {isLoading ? (
                <CircularProgress
                  sx={{
                    height: "25px !important",
                    width: "25px !important",
                    "--CircularProgress-size": "8px",
                    "--CircularProgress-trackThickness": "1px",
                    "--CircularProgress-progressThickness": "1px",
                  }}
                  color="inherit"
                />
              ) : (
                "Delete"
              )}
            </Button>
          </div>
        </>
      }
    >
      <Box>
        <div className="text-center mb-3">
          {/* <DeleteIcon className="dlt-error-color" sx={{ fontSize: 50 }} /> */}
          <span className="material-symbols-outlined dlt-error-color delete-icon-size">
            delete
          </span>
        </div>
        <Typography className="remove-item-css text-center" pl={1}>
          <b>Are you sure want to remove {entity}?</b>
        </Typography>
      </Box>
    </Dialog>
  );
};

export default DeleteDialog;
